import type { HistoryStep } from './types';

/**
 * Instance identity rule (used consistently for step keys, group snapshot
 * keys, and instance comparisons): the SurveyAnswerGroup id when known,
 * otherwise the session-local instance sequence. answerGroupId is the only
 * globally-correct identity (survives backend-resumed multi instances that
 * share a local instanceSeq); instanceSeq covers the window before the
 * answer group is lazily created.
 */
export function instanceKeyOf(
  answerGroupId: number | null | undefined,
  instanceSeq: number
): string {
  return answerGroupId != null ? String(answerGroupId) : 's' + instanceSeq;
}

/**
 * Key for per-instance group snapshots (interviewSlice.groupsById).
 * One snapshot per (group, instance) so reviewing an older instance of a
 * multi group renders its own instance_label and existing_answer values.
 */
export function makeGroupInstanceKey(
  groupId: number | null,
  answerGroupId: number | null | undefined,
  instanceSeq: number
): string {
  return `${groupId}:${instanceKeyOf(answerGroupId, instanceSeq)}`;
}

export function makeStepKey(s: HistoryStep): string {
  if (s.kind === 'user_profile_field') {
    return `p:${s.fieldName}`;
  }

  return `q:${s.groupId}:${instanceKeyOf(s.answerGroupId, s.instanceSeq)}:${
    s.qitId
  }`;
}
